import React, { createContext, useContext, useState } from "react";

const ManagementContext = createContext();

export const ManagementProvider = ({ children }) => {
  const [managementData, setManagementData] = useState({
    managementStats: {
      categories: [],
      suppliers: [],
      units: [],
      products: [],
      users: [],
    },
    lastFetched: null,
  });

  const [loading, setLoading] = useState(true);
  const [showTermModal, setShowTermModal] = useState(false);

  return (
    <ManagementContext.Provider
      value={{
        managementData,
        setManagementData,
        loading,
        setLoading,
        showTermModal,
        setShowTermModal,
      }}
    >
      {children}
    </ManagementContext.Provider>
  );
};

export const useManagement = () => useContext(ManagementContext);